var _circle, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.407,
    cy: 40.7054,
    r: 39.4807,
    fill: "white",
    stroke: "url(#paint0_linear_389_7140)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1281 60.8594C35.1298 61.296 28.1398 57.8551 24.3836 51.3912C21.8905 47.101 21.2603 42.2327 22.2421 37.7288L23.0235 35.076C24.5172 31.0861 27.3427 27.568 31.3051 25.2654C40.4163 19.9708 52.1363 23.0758 57.431 32.1871C58.9366 34.778 59.7955 37.6191 59.9811 40.545L59.4513 39.9858C58.8671 39.3692 57.8939 39.3429 57.2774 39.927C56.7216 40.4536 56.6454 41.2965 57.0637 41.9089C57.1095 41.976 57.1611 42.0402 57.2184 42.1008L60.3223 45.3772C60.6027 45.6732 60.9894 45.8458 61.3971 45.8567C61.8049 45.8677 62.2002 45.7164 62.4962 45.4359L65.7727 42.3319C66.3891 41.7481 66.4145 40.7749 65.8314 40.158C65.2473 39.5415 64.2741 39.5152 63.6577 40.0992L63.0699 40.656C62.8972 37.1486 61.8909 33.7407 60.0899 30.6414C53.9433 20.0642 40.3372 16.4594 29.7599 22.606C19.1824 28.7527 15.5778 42.3587 21.7244 52.936C26.0678 60.4103 34.136 64.403 42.2282 63.9336L42.1281 60.8594Z",
    fill: "url(#paint1_linear_389_7140)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8002 29.6587C35.91 28.4335 38.3595 27.7285 40.975 27.7285C48.8793 27.7285 55.287 34.136 55.287 42.0405C55.287 49.9447 48.8793 56.3524 40.975 56.3524C33.0708 56.3524 26.6631 49.9447 26.6631 42.0405C26.6631 37.8119 28.4981 34.0131 31.4137 31.3931L33.8002 29.6587ZM39.7337 38.3128C39.7337 39.1222 40.592 39.6371 42.6765 40.4216C45.5945 41.4516 46.7718 42.8003 46.7718 45.0075C46.7718 47.1899 45.2267 49.0538 42.4067 49.5438V52.045H40.0035V49.7156C38.3606 49.6417 36.7668 49.2005 35.8349 48.6611L36.5704 45.7922C37.6004 46.356 39.0469 46.8709 40.641 46.8709C42.0386 46.8709 42.9951 46.3315 42.9951 45.3503C42.9951 44.4189 42.2104 43.8301 40.3957 43.2171C37.7718 42.3346 35.9819 41.1083 35.9819 38.7295C35.9819 36.5714 37.502 34.8793 40.1259 34.3644V32.0351H42.5292V34.1932C44.172 34.2665 45.2755 34.6102 46.0849 35.0026L45.3736 37.7734C45.3178 37.7498 45.2583 37.7239 45.1948 37.6963C44.5337 37.409 43.4534 36.9395 41.8426 36.9395C40.2486 36.9395 39.7337 37.6265 39.7337 38.3128Z",
    fill: "url(#paint2_linear_389_7140)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_389_7140",
    x1: 40.407,
    y1: 0.724609,
    x2: 40.407,
    y2: 80.6861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_389_7140",
    x1: 59.6866,
    y1: 29.5018,
    x2: 21.1275,
    y2: 51.9089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_389_7140",
    x1: 40.975,
    y1: 27.7285,
    x2: 40.975,
    y2: 56.3523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTco);
export default __webpack_public_path__ + "static/media/TCO.702c37d1fbfdd813dab0d4afd048dc49.svg";
export { ForwardRef as ReactComponent };